export const isoTimeTo24HourConverter = (isoTimeFormat) => {
  const [hours, minutes] =  isoTimeFormat.split(':')
  const time24HourFormat = hours + ':' + minutes
  return time24HourFormat
}